export const themes = {
  light: {
    page:        '#f4f4f5',
    card:        '#ffffff',
    shadow:      '0 4px 24px rgba(0,0,0,0.08)',
    border:      '#e5e7eb',
    text:        '#111111',
    textSub:     '#888888',
    textMuted:   '#bbbbbb',
    textLine:    '#222222',
    inputBg:     '#ffffff',
    inputBorder: '#dddddd',
    rowDivider:  '#f0f0f0',
    transcriptBg:'#fafafa',
    timerBg:     '#f0f0f0',
    timerColor:  '#555555',
    indexColor:  '#cccccc',
    accent:      '#4f46e5',
    danger:      '#dc2626',
    toggleBg:    '#f0f0f0',
    toggleColor: '#555555',
  },
  dark: {
    page:        '#0f0f11',
    card:        '#1a1a1f',
    shadow:      '0 4px 24px rgba(0,0,0,0.4)',
    border:      '#2e2e38',
    text:        '#f1f1f1',
    textSub:     '#888888',
    textMuted:   '#444444',
    textLine:    '#e2e2e2',
    inputBg:     '#111116',
    inputBorder: '#2e2e38',
    rowDivider:  '#222228',
    transcriptBg:'#111116',
    timerBg:     '#2a2a32',
    timerColor:  '#aaaaaa',
    indexColor:  '#3a3a44',
    accent:      '#6366f1',
    danger:      '#ef4444',
    toggleBg:    '#2a2a32',
    toggleColor: '#aaaaaa',
  },
};
